import React, { Component } from 'react';
import axios from "axios";
import {TextField, Autocomplete, Drawer, Paper, FormControl, InputLabel, Grid, Container, Button, Table, IconButton, TableHead, TableRow, TableCell, TableBody} from '@mui/material';
import Api from "../../customlib/Api";
import Modal from "react-bootstrap/Modal";
// import { Button, Container, Form, FormGroup, Label, ButtonGroup, Table} from 'reactstrap';
import { FormControlLabel, MenuItem, Select, Switch } from '@mui/material';
import './SettingContact.css'; 
import Global from '../../customlib/Global';
import { Add, Delete, Edit } from '@mui/icons-material';

class SalesManagement extends Component {

    constructor(props) {
      super(props);
      this.state = {
        item: this.emptyCustomer,
        sales: []
      };
      // this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    state = { 
        contacts : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        salesData: [],
        selectedSales : {},//id = id, lavenderSalesId, lavenderSalesName, salesType
        id: 0,
        lavenderSalesId: 0,
        lavenderSalesName: "",
        salesType: "Acquisition",
        checkpointCount: 24,
        bottom: false,
        salesInfo: {}, //id = id, lavenderSalesId, lavenderSalesName, salesType
        showDeleteSalesLavenderDialog: false,
        idDelete:0,
        idSalesDelete:0,
        nameSalesDelete:"",
        allowReceiveLeads: 1,
        isNightShift: false
    }

   
    
    componentDidMount() {
        this.getSaleses();
        this.getSalesTeleUsers();
        this.setState({id: 0});
        
    }

    getSalesTeleUsers = () => {
        axios
        .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeaderJsonNew())
        .then((response) => {
            console.log("SALESTELEUSER : ", response.data.data);
            this.setState({salesData: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };

    getSaleses = () => {
      axios
        .post(Api.getSalesChatList(), {appProfileId: Global.getAppProfile()._id}, Api.getRequestHeaderJsonNew())
        .then((response) => {
            console.log("SALESCHATLIST : ", response.data.data);
            this.setState({sales: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };


    handleAddButton = () => {
        let newData = 
        {
            id: 0,
            lavenderSalesId: 0,
            lavenderSalesName: "",
            salesType: "Acquisition",
            checkpointCount: 24
        };

        const sales = [...this.state.contacts, newData];

        this.setState({contacts: []}, ()=>{
            this.setState({contacts: sales});
        });

    }

    handleSalesTypeChange = (event) => {
      this.setState({
          salesType: event.target.value
      });
    };

    handleCheckpointCountChange = (event) => {
      this.setState({
          checkpointCount: event.target.value
      });
    };

    handleSelectionChanged = (salesName) => {
      const salesData = [...this.state.salesData];
      // console.log("SALESDATA : ", salesData);
      let selected = salesData.filter((sales) => sales.name===salesName);
      console.log("FINDSELECTION : ", selected);

      if(selected.length > 0){
          let newData = JSON.parse(JSON.stringify(selected[0]));
          
          newData.lavenderSalesId = selected.id;
 
          this.setState({
            selectedSales: newData,
            lavenderSalesId: selected[0].id,
            lavenderSalesName: selected[0].name,
          });
          console.log(selected[0].id);
          console.log(selected[0].name);
          

          // console.log(this.state.lavenderSalesId );
          // console.log(this.state.lavenderSalesName);
      }

  }

  editSales = (id, salesId, salesName, salesType, allowReceiveLeads, isNightShift) => {
    // this.state.id = id;
    // this.state.lavenderSalesId = salesId;
    // this.state.lavenderSalesName = salesName;
    // this.state.salesType = salesType;
    // this.state.allowReceiveLeads = allowReceiveLeads;

    // console.log(this.state.id);
    // console.log(this.state.lavenderSalesId );
    // console.log(this.state.lavenderSalesName);
    // console.log(this.state.salesType);

    this.setState({ id: id, lavenderSalesId: salesId, lavenderSalesName: salesName, salesType: salesType, allowReceiveLeads: allowReceiveLeads, isNightShift: isNightShift, bottom: true });
    
  }

  addSales = () => {
    this.setState({ id: 0, lavenderSalesId: 0, lavenderSalesName: "", salesType: "Acquisition", allowReceiveLeads: 1, bottom: true });
  }


  cancel(){
    this.setState({ ...this.state, 'bottom': false });
  }

  async handleSubmit(event) {
    event.preventDefault();
      
    if(this.state.id === ''){
      this.state.id = '0';
    }else{
      // this.state.id = '0';
    }

    // console.log("id--> "+this.state.id);
    // console.log("selectedSales--> "+this.state.lavenderSalesId);
    // console.log("selectedSalesname--> "+this.state.lavenderSalesName);
    // console.log("salesType--> "+this.state.salesType);
    // console.log("appProfileId--> ", Global.getAppProfile()._id);
    
    var params = [
      {
        id: this.state.id, 
        lavenderSalesId: this.state.lavenderSalesId, 
        lavenderSalesName: this.state.lavenderSalesName, 
        salesType: this.state.salesType, 
        allowReceiveLeads: this.state.allowReceiveLeads,
        appProfileId: Global.getAppProfile()._id,
        isNightShift: this.state.isNightShift
      }
    ];

    console.log("PARAMS_SAVE_SALES", params);

    axios
      .post(Api.doSaveSales(), params, 
        Api.getRequestHeader())
      .then((response) => {
        console.log("doSaveSales : ", response.data);
        let responseData = response.data;
        if(responseData.success){
            console.log(responseData);
            // this.props.history.push('/setting');
            this.getSaleses();
            // return;
            
            this.setState({ ...this.state, 'bottom': false });
        }
        // this.setState({contacts: response.data.data});
        
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  handleRemoveSales = () => {
      console.log(this.state.idDelete);
      console.log(this.state.idSalesDelete);

    axios
    .post(Api.deleteSales(), {id: this.state.idDelete, lavenderSalesId: this.state.idSalesDelete}, Api.getRequestHeaderJsonNew())
    .then((response) => {
      console.log("doSaveSales : ", response.data);
      let responseData = response.data;
      if(responseData.success){
          console.log(responseData);
          this.getSaleses();
          this.handleCloseLogoutDialog();
      }
      
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
  }

  handleRemoveSalesDialog = (id, lavenderSalesId, lavenderSalesName) => {

    this.setState({ showDeleteSalesLavenderDialog: true,
                    idDelete: id,
                  idSalesDelete: lavenderSalesId,
                   nameSalesDelete: lavenderSalesName});


  }

  handleSwitchLeads = () => {
    let allowLeads = 0;
    if(this.state.allowReceiveLeads === 1){
      allowLeads = 0;
    }else{
      allowLeads = 1;
    }

    this.setState({allowReceiveLeads: allowLeads});

  }

  handleSwitchNightShift = () => {
    let isNightShift = false;
    if(this.state.isNightShift === true){
      isNightShift = false;
    }else{
      isNightShift = true;
    }

    this.setState({isNightShift: isNightShift});

  }

  handleCloseLogoutDialog = () => {
    this.setState({ showDeleteSalesLavenderDialog: false });
  };
    
    render() { 

      const { sales  } = this.state;

      const toggleDrawer = (anchor, open) => (event) => {
        
        // console.log('this.state.id=> '+this.state.id);
        // if(this.state.id === 0){
        //   // this.setState({
        //     this.state.salesType = 'Acquisition';
        //     this.state.allowReceiveLeads = 1;
        //     // }); 
        // }

        // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        //   return;
        // }

         
        // if(open === false){
          
        //   this.state.id = 0;
        //   this.state.lavenderSalesName = '';
        //   // if(this.state.salesType === ''){
        //     // this.state.salesType = 'Acquisition';
        //   // }else{
        //     this.state.salesType = '';
        //   // }

        //   // this.setState({ id: 0, lavenderSalesName: "", salesType: "", [anchor]: open });

        // }else{
        //   if(open === true && this.state.id === ''){
        //     // this.setState({
        //       this.state.salesType = 'Acquisition';
        //       // [anchor]: open
        //       // }); 
        //   }
        // }

      
        this.setState({[anchor]: open });
      };
 

        return (
          <Paper style={{padding: 20}}>
            <div>
              {/* <AppNavbar/> */}

              <div>

                <Modal
                  show={this.state.showDeleteSalesLavenderDialog}
                  onHide={this.handleCloseLogoutDialog}
                  backdrop="static"
                  keyboard={false}>
                  <Modal.Header closeButton>Konfirmasi</Modal.Header>
                  <Modal.Body>Yakin akan menghapus  {this.state.nameSalesDelete}?</Modal.Body>
                  <Modal.Footer>
                    <span onClick={this.handleRemoveSales} className="btn btn-danger">
                      Ya  
                    </span>
                    <span
                      onClick={this.handleCloseLogoutDialog}
                      className="btn btn-warning" >
                      Batalkan
                    </span>
                  </Modal.Footer>
                </Modal>
                
                  <React.Fragment key={'bottom'}>
                    
                    <Drawer width='40%' anchor={'right'} open={this.state['bottom']} onClose={toggleDrawer('bottom', false)}>
                      {/* {list(anchor)} */}
                      <div role="presentation"
                        // onClick={toggleDrawer('bottom', false)}
                        // onKeyDown={toggleDrawer('bottom', false)}
                      >
                        
                        <Container>
                          <h1>Input Salesman</h1>
                          <hr/>
                          <Grid container spacing={1} sx={{pt: "10px"}}>
                            <Grid item xs={12} sm={12}>
                                {(this.state.salesData && this.state.salesData.length > 0) ? 
                                    <Autocomplete
                                        id="free-solo-2-demo"
                                        // disableClearable
                                        freeSolo 
                                        options={this.state.salesData.map((option) => {
                                            // console.log("LABEL : ", option);
                                            return String(option.name);
                                        })}
                                        
                                        onChange={(event, newValue) => {
                                            // console.log("NEWVALUE : ", event);
                                            this.handleSelectionChanged(newValue);
                                        }} 
                                        // value={this.state.contactData.lavenderSalesName}
                                        value={this.state.lavenderSalesName}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Nama Sales"
                                            // margin="0"
                                            variant="outlined"
                                            InputProps={{ ...params.InputProps, type: 'search' }}
                                            size='small'
                                        />
                                        )}
                                        size='small'
                                    />
                                : 
                                <></>
                                }
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <FormControl fullWidth sx={{mt: "10px"}} size='small'>
                                <InputLabel id="sales_type_cb_labelid">Tipe Sales</InputLabel>
                                <Select
                                    labelId="sales_type_cb_labelid"
                                    id="sales_type_cb"
                                    value={this.state.salesType}
                                    onChange={this.handleSalesTypeChange}
                                    label="Tipe Sales"
                                    size='small'
                                    fullWidth>
                                    <MenuItem value={"Acquisition"}>Acquisition</MenuItem>
                                    <MenuItem value={"Retention"}>Retention</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <FormControlLabel
                                    label= {this.state.allowReceiveLeads === 1 ? "Auto Leads (ON)" : "Auto Leads (OFF)"}
                                    control={
                                      <Switch
                                        checked={this.state.allowReceiveLeads === 1}
                                        onChange={this.handleSwitchLeads}
                                        name="switchLeads"
                                        // color="primary"
                                        size='small'
                                      />
                                    }
                                    
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <FormControlLabel
                                    label= {this.state.isNightShift === true ? "Night Shift (ON)" : "Night Shift (OFF)"}
                                    control={
                                      <Switch
                                        checked={this.state.isNightShift === true}
                                        onChange={this.handleSwitchNightShift}
                                        name="switchNightShift"
                                        // color="primary"
                                        size='small'
                                      />
                                    }
                                    
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                      <Button variant='contained' fullWidth color="primary" onClick={this.handleSubmit}>Save</Button>
                                  </Grid>
                                  <Grid item xs={6}>
                                      <Button variant='contained' fullWidth color="secondary" onClick={() => this.cancel()} >Cancel</Button>
                                  </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Container>
                      </div>
                    </Drawer>
                  </React.Fragment>
              </div>

              {/* <TemporaryDrawer/> */}
          
              <Container> 
                <Grid container spacing={1}>
                  <Grid item xs={10}>
                    <h3>Sales List</h3>
                  </Grid>
                  <Grid item xs={2} textAlign={"right"}>
                    <Button variant='contained' color="success" sx={{textTransform: "capitalize"}} onClick={this.addSales}><Add sx={{mr: "10px"}} /> Add Sales </Button>
                  </Grid>
                </Grid>
                <Table size='small'>
                  <TableHead>
                      <TableCell width="20%">Sales Name</TableCell> 
                      <TableCell width="20%">Sales Type</TableCell> 
                      <TableCell width="10%">Auto Leads</TableCell> 
                      <TableCell width="10%">Night Shift</TableCell> 
                      {/* <TableCell width="10%">Checkpoint</TableCell>  */}
                      <TableCell width="10%">Actions</TableCell>
                  </TableHead>
                  <TableBody>
                      {
                        this.state.sales?.map(saless => {
                          return <TableRow key={saless.id}>
                              {/* <td style={{whiteSpace: 'nowrap'}}>{saless.id}</td> 
                              <td style={{whiteSpace: 'nowrap'}}>{saless.lavenderSalesId}</td>  */}
                              <TableCell style={{whiteSpace: 'nowrap'}}>{saless.lavenderSalesName}</TableCell> 
                              <TableCell style={{whiteSpace: 'nowrap'}}>{saless.salesType}</TableCell> 
                              <TableCell style={{whiteSpace: 'nowrap'}}>{saless.allowReceiveLeads === 1 ? "ON" : "OFF"}</TableCell> 
                              <TableCell style={{whiteSpace: 'nowrap'}}>{saless.isNightShift === true ? "YES" : "NO"}</TableCell> 
                              {/* <TableCell style={{whiteSpace: 'nowrap'}}>{saless.checkpointCount ?? 24}</TableCell>  */}
                              <TableCell>
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <IconButton 
                                      size='small' 
                                      onClick={ () => this.editSales(saless.id, saless.lavenderSalesId, saless.lavenderSalesName, saless.salesType, saless.allowReceiveLeads, saless.isNightShift)} 
                                      color='primary' 
                                      variant='contained'>
                                        <Edit />
                                    </IconButton>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <IconButton 
                                      size="small" 
                                      variant='contained' 
                                      color="erro" 
                                      onClick={() => this.handleRemoveSalesDialog(saless.id, saless.lavenderSalesId, saless.lavenderSalesName)}>
                                        <Delete />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              {/* <ButtonGroup>
                                  
                                  
                                  <Button size="sm" color="danger" onClick={() => this.handleRemoveSales(saless.id, saless.lavenderSalesId)}>Delete</Button>
                                  
                              </ButtonGroup> */}
                              </TableCell>
                          </TableRow>
                      })
                      }
                  </TableBody>
                </Table>
              </Container>
            </div>
          </Paper>
        );

    }
}

export default SalesManagement;
